/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from 'react';
import { withRouter } from 'react-router';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment/moment';
import {
  getAllIneligibleProvider,
  updateIneligibleProvider,
  setErrorMessages,
  setGridData,
  setEditedData,
  resetIneligibleProviderStore,
  validateIneligibleProvider,
  setDeletedData,
  setNewProviderData,
  updateIneligibleProviderAndFetch,
  resetIneligibleProviderTab,
} from '../Store/actions';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  FAILED_MESSAGE_GENERIC,
  JOB_SUBMITTED_TO_NIGHT_MSG,
  SUCCESSMESSAGE_GENERIC,
  INELIGIBLE_PROVIDER_BEFORE_SAVE_MSG,
  INELIGIBLE_PROVIDER_BEFORE_SAVE_MSG_1,
  ING_ERR,
  ING_NEW_CONFIRM,
  ING_CONFIRM,
  ING_BE_ERR,
} from '../../../../SharedModules/Errors/constantMessageData';
import IneligibleProvHeader from './gridComponents/tableHead';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  closeTab,
  getCommonDropdownList,
  validDate,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
  handleTabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import DeleteBoxRender from './gridComponents/deleteBoxFramework';
import BeginEndDateFramework from './gridComponents/BeginEndDateFramework';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import NewProviderModal from './newProviderModal';
import ProviderIdLinkRenderer from './providerIdLinkRenderer';
import { getProviderIdTypeDetails } from '../../../Display/Provider/store/action';
import { navigateToProvider } from '../../../Display/Claim/store/action';
import {
  compareTwoDatesGreaterThanOrEqual,
  formatToCorrectDate,
  getDateInMMDDYYYYFormat,
} from '../../../../SharedModules/DateUtilities/DateUtilities';
import {
  checkActionAccessByRole,
  isReadOnly as isRead,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

function IneligibleProviders(props) {
  const dispatch = useDispatch();
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const data = useSelector((state) => {
    return state.sharedState.TBillTableReducer.rebateTBillSearchResult.data;
  });
  const resultData = useSelector((state) => {
    return state.sharedState.IneligibleProvidersReducer.ineligibleProviderData;
  });

  const errorMessages = useSelector((state) => {
    return state.sharedState.IneligibleProvidersReducer.errorMessagesInRedux;
  });

  const gridData = useSelector((state) => {
    return state.sharedState.IneligibleProvidersReducer.gridData;
  });

  const editedData = useSelector((state) => {
    return state.sharedState.IneligibleProvidersReducer.editedData;
  });

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const addedProviderData = useSelector((state) => {
    return state.sharedState.IneligibleProvidersReducer.addedProviderData;
  });

  const userId = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data?.userId
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const gridRef = React.useRef();
  const [newData, setNewData] = useState([]);
  const [open, setOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [isNew, setIsNew] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [beginDate, setBeginDate] = useState('');
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [localStorageValue, setLocalStorageValue] = useState(null);
  const [childSelected, setChildSelected] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [openErrIngPrv, setOpenErrIngPrv] = useState(false);
  const [gridParams, setGridParams] = React.useState(null);
  const [commonDropdownList, setCommonDropdownList] = React.useState([]);
  const [errorMessageList, setErrorMessageList] = React.useState([]);
  const [focusedRowId, setFocusedRowId] = useState(null); 
  const [hasAccessbyRole, setHasAccessbyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const history = useHistory();
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly = isRead(props.location.pathname, loginState)?.readOnly || false;
  }
  const handleEditedData = (value) => {
    dispatch(setEditedData(value));
  };
  const handleGridData = (value) => {
    dispatch(setGridData(value));
  };
  const searchAllIneligibleProvider = async (value, timeOut) =>{
    // await Promise.resolve();
    setTimeout(() => { 
      dispatch(setEditedData([]));
      dispatch(setGridData([]));
      dispatch(getAllIneligibleProvider({}));
    }, timeOut);
  }
  useEffect(() => {
    setNewData(resultData);
  }, [data]);
  useEffect(() => {
  if (focusedRowId && gridParams?.api) {
    const rowIndex = gridData?.findIndex((x) => x.tempId === focusedRowId);
    if (rowIndex !== -1) {
      gridParams.api.refreshCells({ force: true });
      gridParams.api.ensureColumnVisible('ineligProviderBeginDt');
      gridParams.api.setFocusedCell(rowIndex, 'ineligProviderBeginDt');
      gridParams.api.forEachNode(
        (node) => node.rowIndex === rowIndex && node?.setSelected(true)
      );
      gridParams.api.ensureIndexVisible(rowIndex, null);
      setFocusedRowId(null); // Reset to avoid repeated triggers
    }
  }
}, [focusedRowId, gridData, gridParams]);

  React.useEffect(() => {
    dispatch(setErrorMessages([]));
    getCommonDropdownList({
      codeDomainList: ['PROVIDER_ID_TYPE_CD'],
    }).then((res) => {
      setCommonDropdownList(res);
    });
  }, []);
  useEffect(() => {
    setShowViewHistory(false);
    if (gridData?.length < 1) {
      const values = {};
      searchAllIneligibleProvider(values, 0);
      handleEditedData([]);
    }
    if (data && data.length > 0) {
      setNewData(data);
    }
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccessbyRole(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  // handing by default first row selection function
  const onGridReady = (params) => {
    if (params) {
      setGridParams(params);
      params.api.forEachNode((node) => node?.setSelected(false));
    }
  };

  // handing highlight tab
  React.useEffect(() => {
    if (errorMessages?.length > 0) {
      tabHighLigther('/ineligibleProviders', true);
    } else {
      tabHighLigther('/ineligibleProviders', false);
    }
  }, [JSON.stringify(errorMessages)]);
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      gridData?.filter((x) => {
        return x.addEditRow;
      })?.length > 0
    ) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/ineligibleProviders') {
            item.isFormDirty = true;
          } else if (item.navTo === '/ineligibleProviders')
            item.isFormDirty = false;
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [gridData]);
  // close popup on click button
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/ineligibleProviders' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/ineligibleProviders' && item.isFormSave) {
          item.isFormSave = false;
          if (isFormValid()) {
            masterDataSave(true);
          }
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const isFormValid = () => {
    let localErr = [];
    let rowIndexId = 0;
    if (gridParams?.columnApi && gridParams?.columnApi !== null) {
      gridParams.columnApi.applyColumnState({
        state: [{ colId: 'providerId', sort: '' }],
      });
    }
    const newObj =
      gridData?.filter((x) => {
        return x.newRecord;
      })?.length > 0
        ? [
            ...gridData?.map((item) => {
              item.ineligProviderBeginDtErr = false;
              item.endDtErr = false;
              return item;
            }),
          ]
        : [
            ...gridData
              ?.sort((a, b) => {
                if (a.providerIdTypeName < b.providerIdTypeName) {
                  return -1;
                }
                if (a.providerIdTypeName > b.providerIdTypeName) {
                  return 1;
                }
                return 0;
              })
              ?.map((item) => {
                item.ineligProviderBeginDtErr = false;
                item.endDtErr = false;
                return item;
              }),
          ];
    if (gridData.length > 0) {
      gridData.forEach((item, rowIndex) => {
        if (!item.deleteRecord) {
          rowIndexId = gridData.findIndex((x) => {
            return x.tempId === item.tempId;
          });

          if (
            (item?.ineligProviderBeginDt || item?.endDt) &&
            (validDate(new Date(item?.ineligProviderBeginDt)) === false ||
              validDate(new Date(item?.endDt)) === false)
          ) {
            if (
              item?.ineligProviderBeginDt &&
              validDate(new Date(item?.ineligProviderBeginDt)) === false
            ) {
              newObj[rowIndexId].ineligProviderBeginDtErr = true;
              localErr.push({
                fieldName: `ineligProviderBeginDt${rowIndex}`,
                errorType: 'InvalidDate',
                message: `${
                  constantMessageData.DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE
                } ${rowIndex + 1}.`,
              });
              dispatch(setGridData(newObj));
            } else if (
              item?.endDt &&
              validDate(new Date(item?.endDt)) === false
            ) {
              newObj[rowIndexId].endDtErr = true;
              localErr.push({
                fieldName: `endDt${rowIndex}`,
                errorType: 'InvalidDate',
                message: `${
                  constantMessageData.DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE
                } ${rowIndex + 1}.`,
              });
              dispatch(setGridData(newObj));
            } else {
              newObj[rowIndexId].endDtErr = true;
              newObj[rowIndexId].ineligProviderBeginDtErr = true;
              localErr = localErr?.filter(
                (item) =>
                  item.errorType !==
                  ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
              );
            }
          } else if (item.ineligProviderBeginDt !== undefined) {
            if (
              item.ineligProviderBeginDt === '' ||
              item.ineligProviderBeginDt === null
            ) {
              newObj[rowIndexId].ineligProviderBeginDtErr = true;
              dispatch(setGridData(newObj));
              localErr = localErr?.filter(
                (item) =>
                  item.fieldName !== `ineligProviderBeginDt${rowIndex}` &&
                  item.errorType !==
                    ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
              );
              localErr.push({
                fieldName: `ineligProviderBeginDt${rowIndex}`,
                errorType: 'dateRequired',
                message: `${
                  constantMessageData.INEDIBILITY_PERIOD_BEGIN_DATE_REQ
                } ${rowIndex + 1}.`,
              });
            } else if (
              item?.endDt !== null &&
              item?.endDt !== '' &&
              item?.endDt !== 'Invalid date' &&
              compareTwoDatesGreaterThanOrEqual(
                new Date(item?.endDt),
                moment(new Date(item?.ineligProviderBeginDt))
              )
            ) {
              newObj[rowIndexId].endDtErr = true;
              localErr = localErr?.filter(
                (item) =>
                  item.fieldName !== `endDt${rowIndex}` &&
                  item.errorType !==
                    ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
              );

              localErr.push({
                fieldName: `endDt${rowIndex}`,
                errorType: 'compareDateGreater',
                tabName: 'CoverageGap',
                message: `${
                  constantMessageData.INEDIBILITY_PERIOD_END_DATE_GREATER_THAN_INEDIBILITY_PERIOD_BEGIN_DATE_ERROR
                } ${rowIndex + 1}.`,
              });
            }
          } else if (
            item?.endDt !== null &&
            item?.endDt !== '' &&
            validDate(new Date(item?.endDt)) === false
          ) {
            newObj[rowIndexId].endDtErr = true;
            localErr = localErr?.filter(
              (item) =>
                item.fieldName !== `endDt${rowIndex}` &&
                item.errorType !==
                  ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
            );
            localErr.push({
              fieldName: `endDt${rowIndex}`,
              errorType: 'compareDateGreater',

              message: `${
                constantMessageData.INEDIBILITY_PERIOD_END_DATE_GREATER_THAN_INEDIBILITY_PERIOD_BEGIN_DATE_ERROR
              } ${rowIndex + 1}.`,
            });
            dispatch(setGridData(newObj));
          } else if (
            item?.endDt !== null &&
            item?.endDt !== '' &&
            compareTwoDatesGreaterThanOrEqual(
              new Date(item?.endDt),
              moment(newObj[rowIndexId].ineligProviderBeginDt)
            )
          ) {
            newObj[rowIndexId].endDtErr = true;
            localErr = localErr?.filter(
              (item) =>
                item.fieldName !== `endDt${rowIndex}` &&
                item.errorType !==
                  ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
            );
            localErr.push({
              fieldName: `endDt${rowIndex}`,
              errorType: 'compareDateGreater',
              tabName: 'CoverageGap',
              message: `${
                constantMessageData.INEDIBILITY_PERIOD_END_DATE_GREATER_THAN_INEDIBILITY_PERIOD_BEGIN_DATE_ERROR
              } ${rowIndex + 1}.`,
            });
            dispatch(setGridData(newObj));
          } else {
            newObj[rowIndexId].endDtErr = false;
            newObj[rowIndexId].ineligProviderBeginDtErr = false;

            localErr = localErr?.filter(
              (item) =>
                item.fieldName !== `endDt${rowIndex}` &&
                item.fieldName !== `ineligProviderBeginDt${rowIndex}` &&
                item.errorType !==
                  ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
            );
            dispatch(setGridData(newObj));
          }
        } else {
          return item;
        }
      });
    }
    dispatch(setErrorMessages([...new Set(localErr)]));

    if (localErr.length === 0) {
      const data = doQuartersOverlap([
        ...newObj?.filter((x) => {
          return !x.deleteRecord;
        }),
      ]);
      const quarterOverlap = data[0];
      const overLapProviderList = data[1];
      if (quarterOverlap?.length > 0) {
        const array = [];
        //let msg = '';
        const errList = [];

        // const messageLines = quarterOverlap.map((li, index) => {
        //   newObj[li].ineligProviderBeginDtErr = true;
        //   newObj[li].endDtErr = true;
        //   dispatch(setGridData(newObj));
        //   const providerId = newObj[li]?.providerId;
        //   return (
        //     <li key={li}>
        //       Provider Id #{providerId}
        //       {/* in Row {li + 1} */}
        //     </li>
        //   );
        // });

        const processedProviderIds = new Set();
        const messageLines = [];
        quarterOverlap.forEach((li, index) => {
          newObj[li].ineligProviderBeginDtErr = true;
          newObj[li].endDtErr = true;
          dispatch(setGridData(newObj));
          const providerId = newObj[li]?.providerId;

          if (!processedProviderIds.has(providerId)) {
            processedProviderIds.add(providerId);
            messageLines.push(
              <li key={providerId}>
                Provider Id #{providerId}
                {/* in Row {li + 1} */}
              </li>
            );
          }
        });

        const messageContent = (
          <>
            Ineligibility Period Begin Date and Ineligibility Period End Date
            Overlap on:
            <ul>{messageLines}</ul>
          </>
        );

        dispatch(setGridData(newObj));
        newObj.filter((err, index) => {
          if (quarterOverlap?.includes(index)) {
            errList.push({
              rowId: index,
            });
          }
        });

        array.push({
          fieldName: '',
          errorType: 'quarterOverlap',
          message: messageContent,
          errList: errList,
        });

        const temArr = localErr.filter((err) => {
          if (err.errorType !== 'quarterOverlap') return err;
        });
        localErr = [...temArr, ...array];
      } else {
        localErr = localErr.filter((err) => {
          if (err.errorType !== 'quarterOverlap') return err;
        });
      }

      dispatch(setErrorMessages([...new Set(localErr)]));
      if (localErr.length === 0) {
        const newObj = [...gridData];
        dispatch(
          setGridData(
            newObj?.map((item) => {
              item.endDtErr = false;
              item.ineligProviderBeginDtErr = false;
              return item;
            })
          )
        );
      }
      return !(localErr.length > 0);
    }
    return false;
  };
  const doQuartersOverlap = (dataArray) => {
    const tempObj = [];
    const myArr = [
      ...dataArray?.map((item) => {
        item.ineligProviderBeginDtErr = false;
        item.endDtErr = false;
        return item;
      }),
    ];

    const providerObjList = myArr.map((el, li) => {
      if (
        el.endDt === 'Invalid date' ||
        el.endDt === null ||
        el.endDt === undefined ||
        el.endDt === ''
      ) {
        return {
          ...el,
          ineligProviderBeginDt: new Date(el.ineligProviderBeginDt),
          endDt: new Date('12/31/9999'),
        };
      }
      return {
        ...el,
        ineligProviderBeginDt: new Date(el.ineligProviderBeginDt),
        endDt: new Date(el.endDt),
      };
    });

    const overlap = [];
    for (let i = 0; i < providerObjList.length - 1; i += 1) {
      for (let j = i + 1; j < providerObjList.length; j += 1) {
        // Check if the date ranges overlap

        if (
          new Date(providerObjList[i].ineligProviderBeginDt) <=
            new Date(providerObjList[j].endDt) &&
          new Date(providerObjList[j].ineligProviderBeginDt) <=
            new Date(providerObjList[i].endDt) &&
          providerObjList[j].providerId == providerObjList[i].providerId &&
          providerObjList[j].providerIdTypeCd ==
            providerObjList[i].providerIdTypeCd
        ) {
          // Add the indexes of the overlapping objects to the array
          overlap.push(i, j);
          tempObj.push(providerObjList[i].providerId);
        }
      }
    }
    return overlap?.length > 0
      ? [[...new Set(overlap)], [...new Set(tempObj)]]
      : [];
  };
  useEffect(() => {
    if (
      resultData &&
      resultData.message === 'SUCESS' &&
      !gridData?.length > 0 && !isSaving
    ) {
      const gridDataResultValue =
        resultData?.data?.length > 0 && resultData.data;
      dispatch(setGridData([]));
      if (gridDataResultValue) {
        gridDataResultValue.map((x) => {
          const beginDt = x.ineligProviderBeginDt
            ? x?.ineligProviderBeginDt?.split('/')
            : [];
          const endDt = x.endDt ? x.endDt.split('/') : [];
          x.ineligProviderBeginDt =
            beginDt.length === 3 && beginDt[2].startsWith('00')
              ? formatToCorrectDate(x.ineligProviderBeginDt)
              : x.ineligProviderBeginDt;
          x.endDt =
            endDt.length === 3 && endDt[2].startsWith('00')
              ? formatToCorrectDate(x.endDt)
              : x.endDt;
        });
      }
      handleGridData(gridDataResultValue);
    } else if (resultData?.error === 'API failed') {
      searchAllIneligibleProvider({}, 0);
      dispatch(
        setErrorMessages([
          {
            field: 'APIFailed',
            errorType: 'APIFailed',
            message: FAILED_MESSAGE_GENERIC,
          },
        ])
      );

      setSuccessMessages([]);
    }
  }, [resultData]);

  const clearMessages = () => {
    setSuccessMessages([]);
  };

  const masterDataSave = async (willClose = false) => {
    clearMessages();
    setOpen(false);
    setIsSaving(true);
    let tempObj = [];
    try {
    if (
      gridData?.filter((x) => {
        return x.addEditRow;
      })?.length > 0
    ) {
      if (isFormValid()) {
        tempObj = gridData
          ?.filter((x) => {
            return x.addEditRow;
          })
          ?.map((item) => {
            return {
              ineligProviderIdVO: {
                providerId: item?.providerId,
                providerIdTypeCd: item?.providerIdTypeCd,
                ineligProviderBeginDt: moment(
                  item?.ineligProviderBeginDt
                ).format('MM/DD/YYYY'),
                flag: true,
              },
              oldIneligProviderBeginDt: item?.oldIneligProviderBeginDt
                ? moment(item?.oldIneligProviderBeginDt).format('MM/DD/YYYY')
                : null,
              endDt: item?.endDt
                ? moment(item?.endDt).format('MM/DD/YYYY')
                : null,
              lastUpdateDt: '',
              providerName: item?.providerName,
              oldProviderId: null,
              oldProviderIdTypeCd: null,
              newRecord: item.deleteRecord ? false : !!item?.newRecord,
              updateRecord: item.deleteRecord ? false : !item?.newRecord,
              deleteRecord: item.deleteRecord,
              lastUpdateUserId: userId?.toUpperCase(),
            };
          });

        if (tempObj?.length > 0) {
          if (
            gridData.filter((x) => {
              return (
                !x.newRecord &&
                (x.isUpdateIneligProviderBeginDt || x.isUpdateEndDt)
              );
            })?.length > 0
          ) {
            let message = '';
            let message1 = '';
            const obj = gridData
              .filter((x) => !x.newRecord)
              .map((item) => {
                if (
                  item.isUpdateEndDt &&
                  item.endDt &&
                  new Date(item.endDt) > new Date(item.oldIneligProviderBeginDt)
                ) {
                  message1 += ` Provider ID: ${item.providerId} End Date: ${item.endDt}`;
                } else if (item.isUpdateIneligProviderBeginDt) {
                  message += ` Provider ID: ${item.providerId} Begin Date: ${item.ineligProviderBeginDt}`;
                }
                if (
                  item.isUpdateEndDt &&
                  item.endDt &&
                  new Date(item.endDt) < new Date(item.oldEndDt)
                ) {
                  message1 += ` Provider ID: ${item.providerId} End Date: ${item.endDt}`;
                } else if (item.isUpdateEndDt && item.endDt) {
                  message += ` Provider ID: ${item.providerId} End Date: ${item.endDt}`;
                }
                if (item.isUpdateEndDt && !item.endDt)
                  message += ` Provider ID: ${item.providerId} Begin Date: ${item.ineligProviderBeginDt}`;
                return item;
              });

            if (message1 !== '' && message !== '') {
              const errorObj = [];
              errorObj.push(
                `${INELIGIBLE_PROVIDER_BEFORE_SAVE_MSG_1} ${message1}`
              );
              errorObj.push(
                `${INELIGIBLE_PROVIDER_BEFORE_SAVE_MSG} ${message} Saving Ineligible Providers...`
              );
              setSuccessMessages([...new Set(errorObj)]);
            } else if (message1 !== '') {
              setSuccessMessages([
                `${INELIGIBLE_PROVIDER_BEFORE_SAVE_MSG_1} ${message} Saving Ineligible Providers...`,
              ]);
            } else if (message !== '') {
              setSuccessMessages([
                `${INELIGIBLE_PROVIDER_BEFORE_SAVE_MSG} ${message} Saving Ineligible Providers...`,
              ]);
            }
          }
          console.log("tempObj",tempObj)
          const updateRes = await dispatch(updateIneligibleProviderAndFetch(tempObj));
          console.log("updateRes",updateRes)
          if (updateRes === 'SUCESS') {
            if (
              tempObj?.filter((x) => {
                return x.newRecord;
              })?.length === tempObj.length
            ) {
              setSuccessMessages([SUCCESSMESSAGE_GENERIC,JOB_SUBMITTED_TO_NIGHT_MSG]);
            } else {
              await Promise.resolve();
            setSuccessMessages([SUCCESSMESSAGE_GENERIC,JOB_SUBMITTED_TO_NIGHT_MSG]);
            }
            const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
            const newObj1 = updateTabs?.map((item) => {
              if (item.navTo === '/ineligibleProviders') {
                item.isFormSave = false;
                item.isFormDirty = false;
                item.isFormError = false;
              }
              return item;
            });
            localStorage.setItem('tabItemsData', JSON.stringify(newObj1));
            if (gridParams?.columnApi && gridParams?.columnApi !== null) {
              gridParams.columnApi.applyColumnState({
                state: [{ colId: 'providerId', sort: 'asc' }],
              });
              gridParams.api.refreshCells();
            }
           if (willClose) {
          // dispatch(resetIneligibleProviderStore());
          dispatch(resetIneligibleProviderTab());
            (async () => {
            await Promise.resolve();
              closeTab('/ineligibleProviders', history);
            })();
          }

          } else {
            searchAllIneligibleProvider({}, 0);
            dispatch(
              setErrorMessages([
                {
                  field: 'APIFailed',
                  errorType: 'APIFailed',
                  message: FAILED_MESSAGE_GENERIC,
                },
              ])
            );
            setSuccessMessages([]);
          }
        }
      }
      setIsNew(false);
      setOpen(false);
      setIsDelete(false);
    }
    } finally {
      setIsSaving(false);
    }
  };

  // set save alert open
  const openSave = () => {
    setSuccessMessages([]);
    if (isFormValid()) {
      setOpen(true);
    }
  };

  // set save alert close
  const handleSaveClose = () => {
    setOpen(false);
  };

  // set Cancel alert open
  const openCancelPopup = () => {
    setSuccessMessages([]);
    setOpenCancel(true);
  };

  // set Cancel Alert close and reset all data
  const handleCancel = () => {
    clearMessages();
    dispatch(setErrorMessages([]));
    setOpenCancel(false);
    searchAllIneligibleProvider({}, 0);
    if (gridRef?.current) {
      gridRef.current.clearFilters();
    }
  };

  const frameworkComponents = useMemo(() => {
    return {
      TextBoxRender: (cellInfo) => {
        return (
          <div className="form-wrapper vertical-wrapper">
            <div>
              <TextField
                style={
                  cellInfo.index === cellInfo.data.index
                    ? { borderBottom: '2px solid red' }
                    : {}
                }
                fullWidth
                required
                disabled={isEnablebyRole === false}
                placeholder=""
                inputProps={{ maxLength: 8 }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  cellInfo.node.setDataValue(
                    cellInfo.column.colId,
                    e.target.value
                  );
                }}
                value={cellInfo.value}
              />
            </div>
          </div>
        );
      },
      StartDate: (params) => {
        return (
          <BeginEndDateFramework isEnablebyRole={isEnablebyRole} {...params} />
        );
      },
      EndDate: (params) => {
        return (
          <BeginEndDateFramework isEnablebyRole={isEnablebyRole} {...params} />
        );
      },
      deleteBoxRenderer: (props) => (
        <DeleteBoxRender
          {...props}
          onClick={(data) => {
            dispatch(setDeletedData(data));
            setChildSelected(data);
            setOpenDelete(true);
            clearMessages();
          }}
          readOnly={isReadOnly || !isEnablebyRole}
        />
      ),
      linkRenderer: (cellData) => (
        <ProviderIdLinkRenderer
          {...cellData}
          readOnly={isReadOnly}
          onClick={(value) => {
            gotoProvider(value);
            clearMessages();
          }}
        />
      ),
      providerNameRenderer: (cellInfo) => {
        const name = cellInfo.data && cellInfo.data.providerName;
        if (name && name.length > 15) {
          return (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
            >
              <div>{name}</div>
            </OverlayTrigger>
          );
        }
        return <div>{name}</div>;
      },
    };
  }, [isEnablebyRole]);

  const addNewIneligProvider = () => {
    setIsOpen(true);
    clearMessages();
  };

 const addNewProvider = () => {
    if (selectedRowData?.length > 0) {
      setErrorMessageList([]);
      let addNewId = '';
      setIsNew(true);
      const newDataAdd = [
        ...gridData?.sort((a, b) => {
          if (a.providerIdTypeName < b.providerIdTypeName) {
            return -1;
          }
          if (a.providerIdTypeName > b.providerIdTypeName) {
            return 1;
          }
          return 0;
        }),
      ];
      if (gridParams?.columnApi && gridParams?.columnApi !== null) {
        gridParams.columnApi.applyColumnState({
          state: [{ colId: 'providerId', sort: '' }],
        });
      }

      const newProviderData = {
        providerId: selectedRowData[0]?.providerPK?.providerId,
        providerIdTypeCd: selectedRowData[0]?.providerPK?.providerIdTypeCd,
        ineligProviderBeginDt: '',
        endDt: '',
        lastUpdateDt: '',
        lastUpdateUserId: '',
        providerName: selectedRowData[0]?.name,
        isFromAPI: false,
        addEditRow: true,
        newRecord: true,
        ineligProviderBeginDtErr: false,
        endDtErr: false,
        oldIneligProviderBeginDt: null,
        tempId: uuidv4(),
      };

      const firstDropdownVal = commonDropdownList?.PROVIDER_ID_TYPE_CD?.filter(
        (x) => {
          return (
            x.codeValueID &&
            x.codeValueID?.codeValue == newProviderData.providerIdTypeCd
          );
        }
      );
      if (firstDropdownVal && firstDropdownVal.length > 0) {
        newProviderData.providerIdTypeName =
          firstDropdownVal[0]?.shortDescription;
      }
      addNewId = newProviderData?.tempId;
      newDataAdd.unshift(newProviderData);
      handleGridData([]);
      handleGridData(newDataAdd);
      const payload = [];
      payload.push({
        ineligProviderIdVO: {
          providerId: newProviderData?.providerId,
          providerIdTypeCd: newProviderData?.providerIdTypeCd,
          ineligProviderBeginDt:
            beginDate || newProviderData?.ineligProviderBeginDt,
          flag: true,
        },
        endDt: newProviderData?.endDt,
        lastUpdateDt: '',
        providerName: newProviderData?.providerName,
        oldProviderId: null,
        oldProviderIdTypeCd: null,
        oldIneligProviderBeginDt: null,
        newRecord: true,
        updateRecord: false,
        deleteRecord: false,
        tempId: newProviderData?.tempId,
      });
      if (addedProviderData) {
        payload.unshift(addedProviderData);
      }
      handleEditedData(payload);
      dispatch(setNewProviderData(payload[0]));
      setIsOpen(false);
      setFocusedRowId(addNewId);
    } else {
      setErrorMessageList([constantMessageData.NO_SELECT_PROVIDER]);
    }
  };


  const navigateToPage = (pathName, value) => {
    let updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathName) === -1) {
      updateTabs.push({
        navTo: pathName,
        value: value,
        from: 'ineligibleProviders',
      });
    } else {
      updateTabs = updateTabs.map((item) => {
        if (item.navTo === pathName) {
          return {
            ...item,
            from: 'ineligibleProviders',
          };
        }
        return item;
      });
    }
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

    history.push({
      pathname: pathName,
    });
  };

  const gotoProvider = (selectedProv) => {
    const selectedData = {
      providerId: selectedProv?.data?.providerId,
      providerIdTypeCd: selectedProv?.data?.providerIdTypeCd,
      userID: userId?.toUpperCase() || logInUser?.toUpperCase(),
      // userLastName: 'TEST',
      functionCode: 'Ineligible Provider',
      eventInquryKeyVO: [
        {
          keyType: 'Provider ID',
          key: selectedProv?.data?.providerId,
        },
      ],
    };
    dispatch(getProviderIdTypeDetails());
    dispatch(
      navigateToProvider(selectedData, () => {
        navigateToPage('/providerDetails', 'Provider Details');
      })
    );
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0];
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        PROVIDER_ID: `${selectedRow?.providerId}`,
        PROVIDER_ID_TYPE_CD: `${selectedRow?.providerIdTypeCd}`,
        INELEG_PROVIDER_BEGIN_DT: `${selectedRow?.ineligProviderBeginDt}`,
      });
    }
  };

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
    clearMessages();
  };
  const gridHeight = fullScreenView ? '70vh' : 350;

  const handleDeleteRow = async () => {
    setIsDelete(false);
    setSuccessMessages([]);
    dispatch(setErrorMessages([]));
    const payload = [];
    payload.push({
      ineligProviderIdVO: {
        providerId: childSelected.data.providerId,
        providerIdTypeCd: childSelected.data.providerIdTypeCd,
        ineligProviderBeginDt: childSelected.data.ineligProviderBeginDt,
        flag: true,
      },
      endDt: childSelected.data.endDt,
      lastUpdateDt: childSelected.data.lastUpdateDt,
      providerName: childSelected.data.providerName,
      oldProviderId: null,
      oldProviderIdTypeCd: null,
      oldIneligProviderBeginDt: '',
      newRecord: false,
      updateRecord: false,
      deleteRecord: true,
      addEditRow: true,
    });
    if (childSelected?.data?.isFromAPI) {
      const deleteReq = {
        startDate: childSelected.data.ineligProviderBeginDt
          ? moment(childSelected.data.ineligProviderBeginDt).format(
              'MM/DD/YYYY'
            )
          : null,
        endDate: childSelected.data.endDt
          ? moment(childSelected.data.endDt).format('MM/DD/YYYY')
          : null,
      };

      const deleteRes = await dispatch(validateIneligibleProvider(deleteReq));

      if (deleteRes === ING_BE_ERR) {
        setOpenErrIngPrv(true);
      } else {
        const newDataAdd = gridData?.map((item) => {
          if (item.tempId === childSelected?.data?.tempId) {
            item.newRecord = false;
            item.updateRecord = false;
            item.deleteRecord = true;
            item.addEditRow = true;
          }
          return item;
        });
        dispatch(setGridData(newDataAdd));
        handleEditedData(payload);
      }
    } else {
      const newDataAdd = [...gridData];
      const newDataFilter = newDataAdd?.filter(
        (x) => x.tempId != childSelected.data.tempId
      );
      const payloadFilter = editedData.filter(
        (x) => x.tempId != childSelected.data.tempId
      );
      handleEditedData(payloadFilter);
      dispatch(setGridData(newDataFilter));
    }

    setOpenDelete(false);
    setChildSelected(null);
    clearMessages();
  };

  // Ag-grid
  const addColWidth = document.getElementsByClassName(
    'makeStyles-wrapper-1 main-body container-fluid minimize-sidebar'
  );
  return (
    <div className="tBillPanel custom-check">
      <div className="panel tBillPanel-space pb-0">
        <CommonModal
          data-testid="ineligible-common-modal"
          open={isOpen}
          viewAction
          viewHeader
          onClose={() => {
            setIsOpen(false);
            setErrorMessageList([]);
          }}
          onOk={() => addNewProvider()}
          okTitle="Select"
          closeTitle="Cancel"
          modalTitle="Select Provider"
          childrenComponent={
            <NewProviderModal
              isAdd
              errorMessageList={errorMessageList}
              setErrorMessageList={setErrorMessageList}
              setSelectedRow={(rowData) => setSelectedRowData(rowData)}
            />
          }
        />
      </div>
      <div className="panel tBillPanel-space devider-line pb-0">
        <Spinner load={spinnerLoader || isSaving} />

        <div>
          <SaveCancelPopup
            open={openDelete}
            title="Delete Provider"
            onConfim={() => {
              handleDeleteRow();
              setOpenDelete(false);
            }}
            onCancel={() => setOpenDelete(false)}
            moduleName=""
            content={
              childSelected?.data?.isFromAPI
                ? ING_CONFIRM
                : `${ING_NEW_CONFIRM} ${
                    (childSelected?.node?.rowIndex || 0) + 1
                  } ?`
            }
          />
          <SaveCancelPopup
            open={openErrIngPrv}
            title="Delete Provider"
            isInfo
            onConfim={() => {
              setOpenErrIngPrv(false);
            }}
            onCancel={() => {
              setOpenErrIngPrv(false);
            }}
            content={ING_ERR}
          />
          <SaveCancelPopup
            open={open}
            title="Save"
            onConfim={() => {
              masterDataSave();
            }}
            onCancel={() => {
              setOpen(false);
            }}
          />
          <SaveCancelPopup
            open={openCancel}
            title="Cancel"
            onConfim={() => {
              handleCancel();
            }}
            onCancel={() => {
              setOpenCancel(false);
            }}
          />
        </div>
        <div>
          <CustomSeparator parent1="Maintain" parent2="Ineligible Providers" />
        </div>
        <div>
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessages?.length > 0
                  ? _.map(errorMessages, (l) => l.message)
                  : []
              ),
            ]}
          />
          <DisplaySuccessMessages successMessages={successMessages} />
          {!fullScreenView && hasAccessbyRole && (
            <div className="flex-block justify-end pb-1">
              <div className="btn-wrapper float-right">
                <Button
                  className="btn btn-success btn-save"
                  onClick={openSave}
                  disabled={
                    gridData?.filter((x) => {
                      return x.addEditRow;
                    })?.length < 1 ||
                    isReadOnly ||
                    !isEnablebyRole
                  }
                >
                  {' '}
                  <SVGComponent iconName="Icon-awesome-save" />
                  Save
                </Button>
                <Button
                  className="btn btn-cancel"
                  onClick={() => openCancelPopup()}
                  disabled={
                    gridData?.filter((x) => {
                      return x.addEditRow;
                    })?.length < 1 ||
                    isReadOnly ||
                    !isEnablebyRole
                  }
                >
                  <SVGComponent iconName="Icon-cancel" />
                  Cancel
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="panel tBillPanel-space pb-0 frr-tbl-with-feature">
        <div className="clearfix" />

        <Grid
          ref={gridRef}
          rowData={
            gridData?.length > 0
              ? gridData?.filter((x) => {
                  return !x.deleteRecord;
                })
              : []
          }
          columnDefs={IneligibleProvHeader(localStorageValue, kcRoles)}
          gridHeight={gridHeight}
          gridCall={onGridReady}
          frameworkComponents={frameworkComponents}
          fileName="Ineligible Providers"
          addTxt={
            checkActionAccessByRole(
              process.env.REACT_APP_HIDE_ACCESS_ROLES,
              kcRoles
            ) && 'Add New Ineligible Provider'
          }
          addAction={addNewIneligProvider}
          enterMovesDown
          suppressCellFocus
          exportFile
          noGlobalSort
          handleViewHistory={handleViewHistory}
          onCellFocused={onCellFocused}
          navigateToNextCell={navigateToNextCell}
          tabToNextCell={handleTabToNextCell}
          fullScreenView={fullScreenView}
          handleFullScreenViewClick={handleFullScreenViewClick}
          disableAddAction={
            isReadOnly ||
            !checkActionAccessByRole(
              process.env.REACT_APP_STATE_ONLY_ROLE,
              kcRoles,
              addColWidth
            )
          }
        />
        {showViewHistory && (
          <ViewHistoryComponent
            setShowViewHistory={setShowViewHistory}
            tableName="INELIG_PROVIDER"
            keyValue={keyValue}
          />
        )}
      </div>
    </div>
  );
}
export default withRouter(IneligibleProviders);
